<template>
    <div class="flex flex-col space-y-2">
        <EnhancementBanner :isVisible="true" />
        <HeaderV2 :breadcrumbItems="breadcrumbItems" />
        <hr class="style_line" />
        <ConfigurationHeader
            :page="page"
            :title="title_config_header"
            :subtitle="subtitle"
            :description="description"
            :info-message="infoMessage"
            :progress-percentage="progressPercentage"
            @back-action="handleBackAction"
        />
        <form @submit.prevent="submitForm" methods="post" enctype="multipart/form-data">
            <div class="block-header justify-content-center gap-40 d-flex flex-wrap px-2">
                <div class="ppv2-w-full ppv2-grid ppv2-mt-5" :style="{ gap: normalizeSize(16, true) }">
                    <div class="ppv2-mb-4">
                        <BaseInput
                            v-model="modelTemplate.title"
                            type="text"
                            ref="title"
                            :label="$t('form_model_template_v2.main_information.title.label')"
                            :placeholder="$t('form_model_template_v2.main_information.title.placeholder')"
                            required
                            customClassSize="ppv2-rounded-[15px]"
                        />
                        <!-- Always reserve space -->
                        <small class="ppv2-block ppv2-min-h-[1.25rem] ppv2-text-[#ed4b9e] ppv2-text-sm">
                            {{ errors.title || '' }}
                        </small>
                    </div>
                </div>
            </div>
            <div class="px-2 ppv2-space-y-4">
                <span class="page_custom_label ppv2-min-h-[1.25rem]">{{ $t('form_model_template_v2.customize_label') }}</span>

                <Devis
                    ref="infoPageDevis"
                    :template_id="template_id"
                    @disable-button="isSubmitting = true"
                    @enable-button="isSubmitting = false"
                    :can-modify-model-devis="canModifyModelDevis"
                />
                <div class="bloc_btn_model">
                    <button
                        ref="updateBtn"
                        :disabled="isSubmitting"
                        type="submit"
                        class="btn_submit_model pos_btn_model font_btn_model"
                    >
                        {{ hasEdit ? $t('form_model_template_v2.btn_save') : $t('form_model_template_v2.btn_validate') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import normalizeSize from '../../../utils/normalizeSize'

import HeaderV2 from '../../Shared/HeaderV2.vue'
import BackButton from '../../Shared/BackButton.vue'
import BaseButton from '../../Shared/BaseButton.vue'
import BaseInput from '../../Shared/BaseInput.vue'
import ApiManager from './ApiManager.js'
import Devis from '../../Gestion_template/Devis.vue'
import ConfigurationHeader from '../../Shared/ConfigurationHeader.vue'
import EnhancementBanner from '../../Shared/EnhancementBanner.vue'

export default {
    props: ['baseUrl', 'data', 'hasEdit', 'canModifyModelDevis'],
    components: {
        HeaderV2,
        BackButton,
        BaseButton,
        BaseInput,
        ConfigurationHeader,
        Devis,
        EnhancementBanner,
    },
    data() {
        return {
            infoMessage: '' /* this.$t('configuration.infoMessage'), */,
            progressPercentage: 45,
            selectedCard: null,
            showPanel: false,
            page: null,
            subtitle: '',
            title_config_header: this.$t('form_model_template_v2.config_header.title'),
            description: this.$t('form_model_template_v2.config_header.description'),
            modelTemplate: {
                title: this.data.title || '',
                establishment_id: this.data.establishment_id || '',
                id: this.data.id || 0,
            },
            template_id: this.data.id || 0,
            isSubmitting: false,
            errors: {
                title: '',
            },
            breadcrumbItems: [
                {
                    label: '←',
                    href: this.baseUrl,
                },
                {
                    label:
                        this.hasEdit == true
                            ? this.$t('form_model_template_v2.breadcrumb_edit')
                            : this.$t('form_model_template_v2.breadcrumb_create'),
                },
            ],
        }
    },
    methods: {
        normalizeSize,
        handleBackAction(data) {
            this.page = 'Default'
        },
        showMessageNotification(message, type) {
            this.$toast[type](message)
        },
        async submitForm() {
            if (this.validate()) {
                try {
                    const _data = await ApiManager.update(JSON.stringify(this.modelTemplate))
                    this.template_id = _data.data.modelTemplate.id
                    if (this.$refs.infoPageDevis) {
                        await this.$refs.infoPageDevis.handleSubmit(this.template_id)
                        if (!this.hasEdit) {
                            setTimeout(async () => {
                                this.resetForm()
                                await this.$refs.infoPageDevis.fetchData(0)
                            }, 2000)
                        }
                    }
                    this.showMessageNotification(_data.message, 'success')
                } catch (error) {
                    this.$toast.error(error.response.data.message)
                } finally {
                }
            }
        },
        resetForm() {
            this.modelTemplate.title = ''
            this.modelTemplate.id = 0
        },
        validate() {
            this.errors.title = ''
            let valid = true
            if (this.modelTemplate.title == '') {
                this.errors.title = this.$t('form_model_template_v2.main_information.title.required')
                this.scrollToError('title')
                valid = false
            }
            return valid
        },
        scrollToError(refName) {
            const el = this.$refs[refName]?.$el || this.$refs[refName]
            if (el && typeof el.scrollIntoView === 'function') {
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                })
            }
        },
    },
    async mounted() {
        await this.$nextTick()
        const result = await this.$refs.infoPageDevis.fetchData(this.template_id)
        if (result.template_devis.length === 0) {
            this.$refs.infoPageDevis.generateIA(0)
        }
    },
}
</script>
<style scoped>
.page_custom_label {
    font-family:
        Poppins Medium,
        sans-serif;
    font-size: clamp(12px, 0.729545vw, 16px);
    line-height: 140%;
}
.form_input {
    box-shadow: 0px 1px 2px 0px #0a0d120d;
    border: 1px solid #7b82894d;
    width: 1052;
    height: 48;
    angle: 0 deg;
    opacity: 1;
    gap: 8px;
    border-radius: 15px;
    border-width: 1px;
    padding-top: 10px;
    padding-right: 14px;
    padding-bottom: 10px;
    padding-left: 18px;
}
.style_line {
    border: 1px solid #1e1e1e33;
    angle: 0 deg;
    border-width: 1px;
    margin-top: 2%;
}
.btn_submit_model {
    background: #021832;
    border: 1px solid #021832;
    width: 225px;
    height: 44px;
    angle: 0 deg;
    opacity: 1;
    gap: 8px;
    border-radius: 10px;
    border-width: 1px;
    padding: 10px;
}
.pos_btn_model {
    text-align: center;
}
.font_btn_model {
    font-family:
        Poppins Medium,
        sans-serif;
    font-size: clamp(12px, 0.729545vw, 16px);
    color: #ffffff;
}
.bloc_btn_model {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
